import type { FormSummaryJSONObject } from '@ikegps/core-api';
import { ModalFormComponent, type ModalFormComponentCtx } from '../../components/modal.form/modal.form.component';
import { addStyles } from '../../components/theme';
import { T, Translate } from '../../i18n';
import { m, type MithrilVNode } from '../../mithril';
import { Services } from '../../services';
import { OrgDepartmentSelector } from '../org.department.selector/org.department.selector';
import { CSS, Style } from './form.copy.modal.style';

addStyles(Style);

export class FormCopyModal extends ModalFormComponent {
	private targetForm: FormSummaryJSONObject;
	private departmentSelector: OrgDepartmentSelector;

	constructor(ctx: ModalFormComponentCtx, form: FormSummaryJSONObject) {
		super(ctx);
		this.targetForm = form;
		this.departmentSelector = new OrgDepartmentSelector({ crossOrganization: true });
		this.addState(this.departmentSelector.inputState);
	}

	get nodes(): MithrilVNode {
		return m('div', { className: CSS.container }, [
			m('div', Translate(T.FORM_COPY_TO_DEPARTMENT_DESCRIPTION)),
			m('div', { className: CSS.content }, [
				m('p', Translate(T.FORM_COPY_TO_DEPARTMENT_CONFIRM, { name: this.targetForm.displayname })),
				this.departmentSelector.view(),
			]),
		]);
	}

	override async submit(): Promise<any> {
		const selectedDepartmentId = this.departmentSelector.selectedDepartmentId;
		if (selectedDepartmentId == null) {
			return null;
		}

		return Services.Form.copy(this.targetForm.objectId, selectedDepartmentId);
	}
}
